// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The MCE interface an IDL file declares.
 */
export enum Interface {
  Dispatcher = 0,
  Controller = 1,
}
